import { render, staticRenderFns } from "./invoices.payment.vue?vue&type=template&id=f4b43e30&"
import script from "./invoices.payment.vue?vue&type=script&lang=js&"
export * from "./invoices.payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports